// TopHeader.jsx
import React, { useEffect, useState } from "react";
import TopLogo from "../image/latin_logo.png";
import { Link, useNavigate } from "react-router-dom";
import DepartmentNavbar from "./DepartmentNavbar";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../Redux/common/action";
import { toast } from "react-toastify";
export default function TopHeader() {
  const dispatch = useDispatch();
  const [value, setValue] = useState("");
  const [valuevendor, setValuevendor] = useState("");
  const [valuesetUserDeatils, setUserDeatils] = useState({});
  const router = useNavigate();

  console.log(valuesetUserDeatils);

  const chooseState = (event) => {
    const state = event.target.value;
    dispatch(allapiAction.gethomePro({ state }));
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      setValue(localStorage.getItem("access_token"));
      setValuevendor(localStorage.getItem("access_token_vendor"));

      const userDetails = localStorage.getItem("access_user");

      setUserDeatils(JSON?.parse(userDetails));
    } else {
      setValue("");
      setValuevendor("");
      setUserDeatils({});
    }
  }, []);

  const tokenhave = value || valuevendor ? true : false;
  const all_categories_List = useSelector((state) =>
    state?.allapi?.all_categories_List ? state?.allapi?.all_categories_List : []
  );
  const get_all_cart_itme = useSelector((state) =>
    state?.allapi?.get_all_cart_itme ? state?.allapi?.get_all_cart_itme : []
  );
  const get_user_profile = useSelector((state) =>
    state?.allapi?.get_user_profile ? state?.allapi?.get_user_profile : {}
  );
  const totalSubtotalPrice = get_all_cart_itme.reduce((total, obj) => {
    return total + obj.subtotalprice;
  }, 0);

  if (typeof window !== "undefined" && Object.keys(window).length > 0) {
    const blogids = localStorage.getItem("cart_product");

    var arr = JSON.parse(blogids && blogids);
    var arrss = tokenhave ? get_all_cart_itme && get_all_cart_itme : arr;
  }

  useEffect(() => {
    dispatch(allapiAction.getCategory({}));
    return () => { };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (tokenhave) {
        dispatch(
          allapiAction.getcartitme({
            data: arrss,
          })
        );
      } else {
        if (arrss?.length > 0) {
          dispatch(
            allapiAction.getcartProduct({
              data: arrss,
            })
          );
        }
      }
    }, 500);

    return () => { };
  }, [tokenhave]);

  useEffect(() => {
    if (tokenhave) {
      if (arr?.length > 0) {
        arr.forEach((file) => {
          dispatch(allapiAction.afterLoginAddCart(file));

          var lists = arr.filter((x) => {
            return x.product_id != file?.product_id;
          });

          if (lists?.length == 0) {
            localStorage.removeItem("cart_product");
          } else {
            localStorage.setItem("cart_product", JSON.stringify(lists));
          }

          return () => { };
        });
      }
    }
  }, [get_user_profile]);

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [searchtype, setsearchtype] = useState("");
  const [searchdata, setsearchdata] = useState("");

  const [userselete, setuserselete] = useState(null);

  const loadOptionsPalyer = async (search, loadedOptions, pages) => {
    console.log(loadedOptions);
    console.log(pages);
    const response = await fetch(
      URL.API_BASE_URL +
      `/publicApi/searchareaforproductDis?key=${search}&page=${pages?.page}`
    );
    const responseJSON = await response.json();

    const options = responseJSON?.results?.map((data) => {
      data.value = data?._id;
      data.label = data?.District + ", " + data?.State;

      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: pages?.page + 1,
      },
    };
  };

  const hendlesearchProduct = (e) => {
    setsearchdata(e?.target?.value);

    if (e.key === "Enter") {
      e.preventDefault();

      if (searchtype == "listing") {
        if (userselete) {
          router(
            `/listings?search=${e?.target?.value}&location=${userselete?._id}`
          );
        } else {
          router(`/listings?search=${e?.target?.value}`);
        }
      } else if (searchtype == "lostandfound") {
        router(`/products?search=${e?.target?.value}`);
      } else {
        if (userselete) {
          router(
            `/products?search=${e?.target?.value}&location=${userselete?._id}`
          );
        } else {
          router(`/products?search=${e?.target?.value}`);
        }
      }
    }
  };

  const hensletosearch = (e) => {
    e.preventDefault();

    if (searchtype == "listing") {
      // router(`/listings?search=${searchdata}`);
      if (userselete) {
        router(`/listings?search=${searchdata}&location=${userselete?._id}`);
      } else {
        router(`/listings?search=${searchdata}`);
      }
    } else if (searchtype == "lostandfound") {
      router(`/products?search=${searchdata}`);
    } else {
      if (userselete) {
        router(`/products?search=${searchdata}&location=${userselete?._id}`);
      } else {
        router(`/products?search=${searchdata}`);
      }
    }
  };

  function removeCartItem(e, color, size) {
    dispatch(
      allapiAction.removeCartItem({
        product_id: e,
        color: color,
        size: size,
      })
    );
  }

  return (
    <>
      <header className="site-top-header py-sm-0 py-2 float slow-glow bg-topheader">
        <div className="container-fluid d-flex align-items-center justify-content-between">
          {/* LEFT: Logo */}
          <div className="d-flex align-items-center gap-3 left-group">
            <Link
              to="/"
              className="top-logo-link d-flex align-items-center shimmer-text"
            >
              <img
                src={TopLogo}
                alt="logo"
                className="top-logo-img coin-spin"
              />
            </Link>
          </div>

          {/* CENTER: Search (show on large screens) */}
          <div className="header-search w-50 d-none d-lg-flex align-items-center pulse-fast">
            <input
              className="search-input rounded-pill"
              type="text"
              placeholder='Search "Bracelets"'
              aria-label="Search products"
              onChange={(e) => {
                hendlesearchProduct(e);
              }}
              onKeyDown={(e) => {
                hendlesearchProduct(e);
              }}
            />
            <button
              className="search-btn wobble"
              onClick={(e) => {
                hensletosearch(e);
              }}
              type="button"
            >
              <i className="fas fa-search"></i>
            </button>
          </div>

          {/* RIGHT: Icons / Auth */}
          <div className="gap-3 right-group d-flex align-items-center">
            <Link to="/products" className="icon-btn shimmer-text">
              <i className="fas fa-store d-flex wobble justify-content-center"></i>
              <small className="text-center d-none d-sm-block">STORE</small>
            </Link>

            {/* Auth area: show Sign In / Register if no tokens, else show Account (or Vendor) */}

            {value || valuevendor ? (
              ""
            ) : (
              <Link to="/login" className="icon-btn shimmer-text">
                <i className="fas fa-sign-in-alt d-flex wobble justify-content-center"></i>
                <small className="text-center text-nowrap d-none d-sm-block">
                  SIGN IN
                </small>
              </Link>
            )}
            {value || valuevendor ? (
              ""
            ) : (
              <Link to="/register" className="icon-btn shimmer-text">
                {" "}
                <i className="fas fa-user-plus d-flex wobble justify-content-center"></i>
                <small className="text-center d-none d-sm-block">
                  REGISTER
                </small>
              </Link>
            )}
            {value ? (
              <Link to="/accounts" className="icon-btn shimmer-text">
                {" "}
                <i className="fas fa-user d-flex wobble justify-content-center"></i>
                <small
                  className="text-center d-none d-sm-block"
                  style={{ marginLeft: "0px" }}
                >
                  {valuesetUserDeatils?.fullName}
                </small>
              </Link>
            ) : (
              ""
            )}
            {valuevendor ? (
              <Link to="/seller" className="icon-btn shimmer-text">
                <i className="fas fa-briefcase d-flex wobble justify-content-center"></i>
                <small className="text-center d-none d-sm-block">
                  {" "}
                  {valuesetUserDeatils?.fullName}
                </small>
              </Link>
            ) : (
              ""
            )}

            {/* <Link to="/wishlist" className="icon-btn shimmer-text">
              <i className="fas fa-heart d-flex wobble justify-content-center"></i>
              <small className="text-center d-none d-sm-block">WISHLIST</small>
            </Link> */}

            {/* <Link to="/cart" className="icon-btn cart-btn shimmer-text">
            <i className="fas fa-shopping-cart wobble d-flex justify-content-center">  {" "}
                      {get_all_cart_itme?.length > 0
                        ? get_all_cart_itme?.length
                        : 0}</i>
            <small className="text-center d-none d-sm-block">CART</small>
          </Link> */}
            <div className="ps-cart--mini">
              <Link to="/cart" className="icon-btn shimmer-text mt-2">
                <div style={{ position: "relative" }}>
                  <i className="fas fa-shopping-cart d-flex wobble justify-content-center"></i>

                  {(get_all_cart_itme?.length ?? 0) > 0 && (
                    <span
                      className="cart-badge"
                      style={{
                        position: "absolute",
                        top: -6,
                        right: -6,
                        minWidth: 12,
                        height: 12,
                        padding: "0 5px",
                        borderRadius: 12,
                        background: "red",
                        color: "#fff",
                        fontSize: 8,
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {get_all_cart_itme?.length ?? 0}
                    </span>
                  )}
                </div>

                <small className="text-center d-none d-sm-block">CART</small>
              </Link>


              <div className="ps-cart__content">
                <div className="ps-cart__items">
                  {get_all_cart_itme &&
                    get_all_cart_itme?.map((data, i) => {
                      return (
                        <div className="ps-product--cart-mobile" key={i}>
                          <div className="ps-product__thumbnail">
                            <Link to={"/product/" + data?.pro_sulg}>
                              <img
                                src={URL?.API_BASE_URL + data?.featureImage}
                                alt=""
                                loading="lazy"
                              />
                            </Link>
                          </div>
                          <div className="ps-product__content">
                            <Link to={"/product/" + data?.pro_sulg}>
                              {data?.title}
                            </Link>
                            <p></p>
                            <small>
                              {data?.item} x ₹{data?.afterdiscountprice}
                            </small>
                            &nbsp;&nbsp;
                            <button
                              className="btn btn-danger btn-sm"
                              type="button"
                              onClick={() =>
                                removeCartItem(
                                  data?.productId?._id,
                                  data?.productcolorId?._id,
                                  data?._id
                                )
                              }
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      );
                    })}
                </div>
                <div className="ps-cart__footer">
                  <h3>
                    Sub Total: ₹
                    {totalSubtotalPrice > 0 ? totalSubtotalPrice : 0}
                  </h3>
                  <figure>
                    {tokenhave ? (
                      <Link
                        className="ps-btn"
                        to={get_all_cart_itme.length ? "/cart" : "#"}
                      >
                        View Cart
                      </Link>
                    ) : (
                      <button
                        className="ps-btn"
                        onClick={() => {
                          router("/login");
                          toast.error("You need to login first!");
                        }}
                      >
                        View Cart
                      </button>
                    )}
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <DepartmentNavbar />
    </>
  );
}
